import { render } from "./IconLinkStroke.vue?vue&type=template&id=31780b7e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLinkStroke.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31780b7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31780b7e', __exports__)) {
    api.reload('31780b7e', __exports__)
  }
  
  module.hot.accept("./IconLinkStroke.vue?vue&type=template&id=31780b7e", () => {
    api.rerender('31780b7e', render)
  })

}


export default __exports__